import React from 'react';

import { Annotation } from "../component";
import { ANNOTATION_TYPES } from "../../common/Constants";
import MedicationCardManufacturerChangedLine from "./MedicationCardManufacturerChangedLine";

interface ItemAnnotationProps {
    annotations: Annotation[];
    textSize?: string;
    textColor?: string;
}

function generateAnnotationLine(annotation: Annotation, textSize: string, textColor?: string) {
    const icon = annotation.annotationType === ANNOTATION_TYPES.PAY_FIXUP
        ? <pui-icon imgClass="status-error-icon" spacingRight="small" />
        : <pui-icon imgClass="status-info-icon" spacingRight="small" />
    
    if (textColor === undefined) {
        textColor = 'black';
    }
    return (<pui-stack
        key={annotation.label}
        style={{ textDecoration: "none" }}
        direction="horizontal"
        mainAxisArrangement="start"
    >
        {icon}
        <pui-text input={annotation.label} textColor={textColor} textSize={textSize} />
    </pui-stack >)
}

export function generateAnnotationLinePillpack(annotation: Annotation, textSize: string, textColor: string) {
    if (annotation.annotationType !== ANNOTATION_TYPES.PAY_FIXUP
        && annotation.annotationType !== ANNOTATION_TYPES.REFUND
        && annotation.annotationType !== ANNOTATION_TYPES.ITEM_CANCELLED_ON
        && annotation.annotationType !== ANNOTATION_TYPES.REPLACES
        && annotation.annotationType !== ANNOTATION_TYPES.REPLACED_BY) {
        return null;
    }

    let annotationColor = textColor;

    switch (annotation.annotationType) {
        case ANNOTATION_TYPES.PAY_FIXUP:
        case ANNOTATION_TYPES.ITEM_CANCELLED_ON:
            annotationColor = "red";
            break;
        case ANNOTATION_TYPES.REFUND:
            annotationColor = "green";
            break;
        case ANNOTATION_TYPES.REPLACES:
        case ANNOTATION_TYPES.REPLACED_BY:
            annotationColor = "green";
            break;
        default:
            annotationColor = textColor;
    }

    return (
        <pui-text key={annotation.label} input={annotation.label} textColor={annotationColor} textSize={textSize} fontWeight="bold" />
    );
}

export function generateAnnotationSubLinePillpack(annotation: Annotation) {
    if (annotation.annotationType !== ANNOTATION_TYPES.MANUFACTURER_CHANGED) {
        return null;
    }

    switch (annotation.annotationType) {
        case ANNOTATION_TYPES.MANUFACTURER_CHANGED:
            return <MedicationCardManufacturerChangedLine
                hasManufacturerChanged={true}
                hasManufacturerChangedLabel={annotation.label}
            />
        default:
            return;
    }
}

export default ({annotations, textSize="medium", textColor}: ItemAnnotationProps) => {
    const duplicates = new Set();

    const suppressPayFixup = annotations.some(
        (annotation) => annotation.annotationType === ANNOTATION_TYPES.SUPPRESS_PAY_FIXUP);

    const annotationChild = annotations
        .filter(annotation => annotation.annotationType !== ANNOTATION_TYPES.CANCEL)
        .filter(annotation => annotation.annotationType !== ANNOTATION_TYPES.SUPPRESS_PAY_FIXUP)
        .filter(annotation => suppressPayFixup?annotation.annotationType !== ANNOTATION_TYPES.PAY_FIXUP:true)
        .filter(annotation => {
            const isDuplicate = duplicates.has(annotation.annotationType);
            duplicates.add(annotation.annotationType);
            return !isDuplicate;
        })
        .map(annotation => {
            duplicates.add(annotation.annotationType)
            return generateAnnotationLine(annotation, textSize, textColor);
        });

        return (<> 
            {annotationChild}
        </>)
}